//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileSpecial",
  props: {
    ntwoData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    specialList: function specialList() {
      return this.ntwoData || [];
    },
    cssVars: function cssVars() {
      return {
        "--ms-spacing": "16px",
        "--ms-radius": "12px",
        "--ms-font-xl": "22px",
        "--ms-text": "#1a1a2e",
        "--ms-padding-top": "20px",
        "--ms-section-title-font-size": "16px",
        "--ms-section-title-mb": "12px",
        "--ms-list-gap": "10px",
        "--ms-item-height": "80px",
        "--ms-deco-size": "80px",
        "--ms-name-font-size": "13px",
        "--ms-name-mt": "2px"
      };
    }
  },
  methods: {
    getTopicIcon: function getTopicIcon(id) {
      try {
        return require("@/assets/home_phone/topic_".concat(id, ".png"));
      } catch (e) {
        return "";
      }
    },
    handleClick: function handleClick(item) {
      if (item.id === 1) {
        this.$router.push("/deYu");
      } else if (item.id === 2) {
        this.$router.push("/tiYu");
      } else if (item.id === 3) {
        this.$router.push("/meiYu");
      } else if (item.id === 4) {
        window.open("https://ldjy.ykt.eduyun.cn/zjldjy");
      }
    }
  }
};